import { render, staticRenderFns } from "./UsuarioTransportistaGrid.vue?vue&type=template&id=15d24bcb&scoped=true&"
import script from "./UsuarioTransportistaGrid.vue?vue&type=script&lang=js&"
export * from "./UsuarioTransportistaGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d24bcb",
  null
  
)

/* custom blocks */
import block0 from "./UsuarioTransportistaGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports